<template>
  <!-- 挽留弹窗 -->
  <div class="detention" v-show="show_detention">
    <div class="mask" @touchmove.prevent></div>
    <div
      class="content"
      :class="{ content_ipad: is_ipad, detention_scale: show_detention }"
    >
      <div class="detention_icon">
        <img src="../img/detention_icon.png" alt />
      </div>
      <div class="btn_container">
        <div class="close_btn" @click="closePage"></div>
        <div class="open_btn" @click="appDirectPay">
          <div class="open_price">
            <div class="price_tag">¥</div>
            <div class="price_num">{{ userPrice }}</div>
          </div>
          <div class="save_container">
            <div class="save_tag">立省</div>
            <div class="save_num">¥{{ userPriceSavePrice }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { h5directpay } from "@/assets/js/common/hybrid/kkhybrid";
import { unfix } from "../js/fix_ele";

const { log } = console;

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState([
      "show_detention",
      "topic_id",
      "comic_id",
      "third_activity",
      "open_price",
      "original_price",
      "is_ipad",
    ]),
    userPrice: function () {
      let coupon_price =
        this.open_price.coupon != undefined ? this.open_price.coupon.amount : 0;

      return this.open_price.price - coupon_price / 100;
    },
    userPriceSavePrice: function () {
      return this.original_price - this.userPrice;
    },
  },
  methods: {
    ...mapMutations([
      "SET_SHOW_DETENTION",
      "SET_REFRESH_MEMBERGOOD_LIST",
      "SET_REFRESH_DATA",
      "SET_SHOW_LOADING",
    ]),
    // 关闭页面
    closePage() {
      this.$kkmh.requestHybrid({
        schema: "kkmhhybrid",
        tagname: "finish",
        callback(res) {},
        param: {
          finish_style: 1, //1-正常关闭 (从左到右滑动关闭),2-直接关闭(无滑动)
        },
      });
    },
    // 关闭弹窗
    close() {
      let fixele = document.querySelector(".home");
      unfix(fixele);

      this.SET_SHOW_DETENTION(false);
    },
    // 格式化客户端返回res
    formatRes(res) {
      if (!res.code) {
        return res.data;
      }
      return res;
    },
    // 端内唤起收银台直接支付
    appDirectPay() {
      log("唤起收银台", this.third_activity);
      this.close();
      this.SET_SHOW_LOADING(true);
      let pay_info = JSON.stringify({
        topic_id: this.topic_id,
        comic_id: this.comic_id,
        coupon_id:
          this.open_price.coupon.id != 0
            ? this.open_price.coupon.id.toString()
            : "",
        third_activity: this.third_activity,
      });
      h5directpay({
        data: {
          pay_info: pay_info,
          track_info: {
            TriggerPage: this.$kkmh.qs()["origin"]
              ? this.$kkmh.qs()["origin"]
              : "homepage",
            CurPage: "联合会员买1赠N活动",
          },
          good_id: this.open_price.id,
          good_type: 1, //0-kkb 1-vip
          pay_source: 2, //活动页
          from_page: "联合会员买1赠N活动",
        },
        callback: (res) => {
          log("调起收银台回调", res);

          if (res.data.pay_status == 4) {
            log("好友代付成功", res);
            // 1.5s后刷新数据，以防到账有延迟
            setTimeout(() => {
              this.SET_REFRESH_DATA(true);
              this.SET_SHOW_LOADING(false);
            }, 1500);
          }

          if (res.data.pay_status == 3) {
            log("点击空白关闭", res);
            this.SET_SHOW_LOADING(false);
          }

          let { code, data = {}, message = "" } = this.formatRes(res);
          if (code !== 200) {
            this.$showToast("返回数据异常, 请稍候再试!");
            return false;
          }
          var resultMap = {
            1: "支付成功",
            2: "支付失败",
            3: "取消",
            4: "好友代付",
            5: "请稍后再试", //实际为：没有找到对应商品，此处只为hack客户端问题
            6: "好友代付回退",
            7: "选中支付方式", // 重新获取商品
          };

          if (data.pay_status == 1) {
            log("支付成功", data);
            this.$showToast("开通成功，请至页面内领取");
            // 1.5s后刷新数据，以防到账有延迟
            setTimeout(() => {
              this.SET_REFRESH_DATA(true);
              this.SET_SHOW_LOADING(false);
            }, 1500);

            this.$doTrack({
              name: "立即抢购",
              MembershipPrdName: this.open_price.title,
              CurrentPrice: this.open_price.price,
              IsOpenSuccess: 1,
            });
          }
          if (data.pay_status == 2 || data.pay_status == 3) {
            log("支付失败||支付取消");
            this.$doTrack({
              name: "立即抢购",
              MembershipPrdName: this.open_price.title,
              CurrentPrice: this.open_price.price,
              IsOpenSuccess: 0,
            });
          }

          if (data.pay_status == 7 && data.pay_payment.type == 4) {
            log("重新获取iap商品", data);
            this.SET_REFRESH_MEMBERGOOD_LIST(true);
            this.$showToast("支付环境已更新,请重新选择支付");
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/common.scss";
.detention {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
}

.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.85);
}
.content {
  @include boxsize(750, 826);
  @include hcenter(750);
  position: absolute;
  top: 18.2%;
  transform: scale(0);

  .detention_icon {
    width: trans(750);
    img {
      width: 100%;
      display: block;
    }
  }
}
.content_ipad {
  top: 8%;
}
.btn_container {
  @include layout(space-between, center);
  width: trans(522);
  margin: 0 auto;
  margin-top: trans(35);
  .close_btn {
    @include boxsize(190, 82);
    @include bgimg("../img/close-dentention.png", 100%, 100%);
  }
  .open_btn {
    @include boxsize(307, 82);
    @include bgimg("../img/open-btn.png", 100%, 100%);
    position: relative;
    .open_price {
      @include layout(center, center);
      flex-wrap: nowrap;
      position: absolute;
      left: trans(170);
      top: trans(6);
      .price_tag {
        @include fontstyle(#ff4031, 40);
        font-weight: bold;
      }
      .price_num {
        @include fontstyle(#ff4031, 50);
        line-height: trans(60);
        font-weight: bold;
      }
    }
    .save_container {
      @include layout(center, center);
      height: trans(36);
      padding: 0 trans(15);
      flex-wrap: nowrap;
      font-size: 0;
      background: #ff3333;
      border-radius: trans(18) trans(18) trans(18) trans(4);
      position: absolute;
      right: trans(8);
      top: trans(-22);
      .save_tag {
        @include fontstyle(#fff, 20);
        line-height: 1.15;
        font-weight: bold;
      }
      .save_num {
        @include fontstyle(#fee437, 22);
        line-height: 1.15;
        font-weight: bold;
        margin-left: trans(5);
      }
    }
  }
}
.detention_scale {
  animation: detentionScale 0.2s 0.2s ease-in-out both;
}
@keyframes detentionScale {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/act/202010/unit_member/comp/Detention.vue